const hapticFeedback = (amount) => {
    if (window?.webkit?.messageHandlers?.hapticFeedback) {
        window.webkit.messageHandlers.hapticFeedback.postMessage(amount)
    } else if (typeof Android !== "undefined" && Android?.hapticFeedback) {
        Android.hapticFeedback(amount)
    } else {
        console.debug(`Send "hapticFeedback('${amount}')" to app`)
    }
}

export {hapticFeedback}